/* Built In Imports */
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
/* External Imports */
import { CheckIcon } from '@chakra-ui/icons';
import { Box, Checkbox, Image, Link, Text, Radio, RadioGroup } from '@chakra-ui/react';
import parser from 'html-react-parser';

/* Internal Imports */
/* Components */
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import SannidhiSectionTitle from './SannidhiSectionTitle';
import CardInfo3 from '@components/Card/CardInfo3';
/* Services */

/**
 * Renders the Sannidhi Program Detail content component
 * @param {Object} sectionContent - Data for section
 * @returns {ReactElement} Sannidhi Program content component
 */

const ProgrmDetails = (sectionContent, region, lang) => {
  const moduledata = sectionContent.pageBody;
  const prgUrl = refineUrlDomain(moduledata[2]?.linkUrl, region, lang);
  return (
    <Box
      w="100%"
      p={{
        base: '10px 0 5px 0',
        sm: '10px 0 5px 0',
        md: '10px 0 15px 0',
      }}
      textAlign={'center'}
      marginBottom="30px"
      marginTop={{ base: '15px', sm: '15px', md: '10px' }}
    >
      <Box
        as="div"
        m="0 auto 30px auto"
        width={{ base: '90%', sm: '90%', md: '730px', lg: '730px' }}
      >
        <SannidhiSectionTitle titleObj={moduledata[0]} />
      </Box>
        <CardInfo3
          sectionContent={moduledata[1]}
          region={region}
        />
      <Box
        as="div"
        textAlign="center"
        m="50px auto 60px auto"
        width={{ base: 'auto', sm: 'auto', md: '400px', lg: '400px' }}
        id="registernow"
      >
        <NextLink
          href={prgUrl}
          passHref
          legacyBehavior>
          <Link
            mt="20px"
            maxW={'auto'}
            textAlign="center"
            minH="52px"
            cursor={prgUrl ? 'pointer' : 'default'}
            bgColor={prgUrl ? '#cf4520' : '#cf452082'}
            fontWeight={500}
            disabled={prgUrl != '#' ? false : true}
            fontFamily="FedraSansStd-medium"
            fontSize={'18px'}
            padding="16px"
            borderRadius="5px"
            color="#faf7f0"
            textDecoration="none"
            _hover={{
              bg:
              prgUrl ? '#000054' : '#cf452082',
            }}
          >
            {moduledata[2]?.buttonText}
          </Link>
        </NextLink>
      </Box>
    </Box>
  );
};

export default ProgrmDetails;